import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IInnerItem, RaUiRadioButtonModule } from '@ra-web-tech-ui-toolkit/components';
@Component({
  selector: 'app-organization-column-renderer',
  standalone: true,
  imports: [CommonModule, RaUiRadioButtonModule],
  styleUrls: ['./organization-column-renderer.component.scss'],
  templateUrl: './organization-column-renderer.component.html',
})
export class OrganizationColumnRendererComponent implements AgRendererComponent {
  public params: ICellRendererParams;
  value: string;
  organizationName: string;
  organizationDesc: string;

  radioButton: IInnerItem[];

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.organizationName = this.params.data.name;
    this.organizationDesc = this.params.data.description;
    this.radioButton = [{ value: this.params.data.id, label: this.organizationName }];
  }

  // Optional - Return true if you want to manage a cell refresh yourself, otherwise return false.
  // If you return false, the grid will remove the component from the DOM and create  a new component in its place
  // with the new values.
  refresh(): boolean {
    return false;
  }

  setValue(value: string): void {
    this.value = value;
  }

  clicked(): void {
    // We need to deselect the previously selected radio button
    // workaround as WTUI does not support grouping based on name for radio button
    this.params.api?.getCellRendererInstances({ columns: ['name'] })?.forEach((cell: any) => {
      cell.setValue(this.params.data.id);
    });
  }
}
